// BL-2467 — the `staff_unreads_snapshot.topic_id` for one person at one house: a
// name-based (v5) UUID of the (tenant, staff user) pair. ADR 056 — Delivery
// Record § 9(c)'s declared deviation from ADR 011 — Durable Events § 2: staff
// work at several houses, so the count is keyed by the pair, and the shared
// snapshot writer and catch-up each take one UUID key. Pure and isomorphic: the
// writer, the catch-up's authorize and the client all compute the same key.

import { v5 as uuidv5 } from 'uuid';

/**
 * The fixed v5 namespace for staff unread-count keys. Never change it: every
 * stored `topic_id` was computed under it.
 */
export const STAFF_UNREADS_TOPIC_NAMESPACE = '6f3c1c1e-6b1e-5a4f-9a59-2b7f0d3e8a41';

/**
 * The snapshot key for one staff member's unread @Inbox count at one house.
 *
 * @param input - the house and the person, both UUIDs.
 * @returns the name-based UUID of the pair (same input, same output, everywhere).
 */
export function staffUnreadsTopicId(input: { tenantId: string; staffUserId: string }): string {
    return uuidv5(`${input.tenantId.toLowerCase()}:${input.staffUserId.toLowerCase()}`, STAFF_UNREADS_TOPIC_NAMESPACE);
}
